import { render, staticRenderFns } from "./tqStandingPointsBar.vue?vue&type=template&id=ea21b9cc&scoped=true&"
import script from "./tqStandingPointsBar.vue?vue&type=script&lang=js&"
export * from "./tqStandingPointsBar.vue?vue&type=script&lang=js&"
import style0 from "./tqStandingPointsBar.vue?vue&type=style&index=0&id=ea21b9cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea21b9cc",
  null
  
)

export default component.exports